export function buildReturnUrl({ service, purchaseId }) {
  return `${window.location.origin}/checkout?service=${service}&purchaseId=${purchaseId}`;
}
